import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { UserData } from '../../models/userData';
import { UserApiService } from './user.api.service';


@Injectable()
export class UserDomainService {

    constructor(private userApiService: UserApiService) { }

    getUserData(): Promise<UserData> {
        return this.userApiService.getUserData();
    }

    updateUserData(userData: UserData): Promise<any> {
        return this.userApiService.setUserData(userData);
    }

    login(googleUser: any): Observable<any> {
        return this.userApiService.login(googleUser);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/user/user.domain.service.ts